/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { Handle } from './handle';

export interface Props {
  children: React.ReactNode;
  columns?: number;
  label?: string;
  style?: React.CSSProperties;
  horizontal?: boolean;
  hover?: boolean;
  handleProps?: React.HTMLAttributes<any>;
  scrollable?: boolean;
  shadow?: boolean;
  placeholder?: boolean;
  unstyled?: boolean;
  onClick?(): void;
  onRemove?(): void;
  containerId: string;
}

export type { Props as ContainerProps };

type ContainerRef = React.ForwardedRef<HTMLDivElement | HTMLButtonElement>;

export const Container = forwardRef<HTMLDivElement | HTMLButtonElement, Props>(
  (
    {
      children,
      columns = 1,
      handleProps,
      onClick,
      label,
      placeholder,
      style,
      containerId,
      hover,
      ...props
    }: Props,
    ref: ContainerRef,
  ) => {
    const Component = onClick ? 'button' : 'div';

    return (
      <Component
        {...props}
        ref={ref as any}
        data-container-id={containerId}
        data-hover={hover}
        style={
          {
            ...style,
            '--columns': columns,
          } as React.CSSProperties
        }
        onClick={onClick}
        tabIndex={onClick ? 0 : undefined}
      >
        {label ? (
          <div>{label}</div>
        ) : (
          <Handle {...handleProps} containerId={containerId} />
        )}
        {placeholder ? (
          children
        ) : (
          <ul style={{ paddingInlineStart: 0 }}>{children}</ul>
        )}
      </Component>
    );
  },
);

export default Container;
